import { Decodable } from './_decodable';
import { toAmount } from 'app/helpers/money';

class PurchaseOrderItem extends Decodable {
    id?: number;
    purchaseOrderId?: number;
    unitId?: number;
    productId?: number;
    name?: string;
    perUnit: number = 0;
    total: number = 0;
    quantity: number = 1;
    ordem: number = 1;
    productCode?: string;
    productImage?: string;
    productDescription?: string;
    productCategoryName?: string;
    productUnit?: string;
    createdAt?: Date;
    updatedAt?: Date;

    // A API manda decimais como texto ("2.90"); o campo de moeda precisa de número
    protected _map = {
        perUnit: (e: any) => toAmount(e),
        total: (e: any) => toAmount(e),
        quantity: (e: any) => e === null || e === undefined ? 1 : Number(e),
        createdAt: (e: any) => this.parseDate(e),
        updatedAt: (e: any) => this.parseDate(e),
    };
}

export { PurchaseOrderItem };
